import React, { PropsWithChildren, useContext } from "react";
import EventEmitter, { Emitter, Listener } from "../../utils/EventEmitter";

interface CommentResolvedData {
    id: number;
}

interface SafeDeskEventTypes {
    commentResolved: CommentResolvedData;
    commentAwared: CommentResolvedData;
    taskSaved: CommentResolvedData;
}

interface SafeDeskEventData {
    eventListener?: Listener<SafeDeskEventTypes>;
    eventEmitter?: Emitter<SafeDeskEventTypes>;
}

const EventContext = React.createContext<SafeDeskEventData>({});
const eventEmitter = new EventEmitter<SafeDeskEventTypes>();
Object.freeze(eventEmitter);
export default eventEmitter;

export function SafeDeskEventProvider({ children }: PropsWithChildren) {
    const eventEmitter = new EventEmitter<SafeDeskEventTypes>();
    return (
        <EventContext.Provider value={{ eventEmitter: eventEmitter, eventListener: eventEmitter }}>
            {children}
        </EventContext.Provider>
    );
}

export function useSafeDeskEvents() {
    return useContext(EventContext);
}